import React from "react";
import { AlertTriangle, Zap } from "lucide-react";
import { useReveal } from "../hooks/useReveal";

const problems = [
  "Strona nie sprzedaje",
  "Brak klientów z internetu",
  "Przestarzały, nieaktualny wygląd",
  "Brak zaufania u odwiedzających",
];

const solutions = [
  "Strona zaprojektowana pod konwersję",
  "Klienci dzwonią i piszą sami",
  "Świeży, premium design w Twoich kolorach",
  "Profesjonalny wizerunek od pierwszej sekundy",
];

export const ProblemSolution = () => {
  const ref = useReveal();
  return (
    <section
      ref={ref}
      data-testid="problem-solution-section"
      className="relative py-24 md:py-32 px-6 md:px-10"
    >
      <div className="max-w-6xl mx-auto">
        <div className="reveal text-center max-w-3xl mx-auto mb-16">
          <span className="text-xs tracking-[0.2em] uppercase text-stormly-cyan font-bold">
            Cisza przed burzą
          </span>
          <h2 className="font-heading font-bold text-4xl sm:text-5xl md:text-6xl mt-4 leading-tight">
            Twoja strona ma działać.{" "}
            <span className="text-white/50">Nie tylko wyglądać.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-10">
          {/* Problems */}
          <div
            data-testid="problems-card"
            className="reveal reveal-delay-1 relative bg-[#1F1F38] border border-white/10 rounded-3xl p-8 md:p-10"
          >
            <div className="flex items-center gap-3 mb-6">
              <div className="h-10 w-10 rounded-xl bg-red-500/10 border border-red-500/30 flex items-center justify-center">
                <AlertTriangle size={18} className="text-red-400" />
              </div>
              <span className="text-xs tracking-[0.18em] uppercase text-red-400/80 font-bold">
                Tak teraz nie pracuje
              </span>
            </div>
            <h3 className="font-heading text-2xl md:text-3xl font-bold mb-6">
              Problem
            </h3>
            <ul className="space-y-4">
              {problems.map((p, i) => (
                <li
                  key={i}
                  className="flex items-start gap-3 text-white/75 text-base"
                >
                  <span className="mt-2 h-1 w-6 bg-red-400/50 shrink-0 rounded-full" />
                  {p}
                </li>
              ))}
            </ul>
          </div>

          {/* Solution */}
          <div
            data-testid="solution-card"
            className="reveal reveal-delay-2 relative bg-gradient-to-br from-[#22264a] to-[#1F1F38] border border-stormly-cyan/30 rounded-3xl p-8 md:p-10 overflow-hidden"
          >
            <div
              className="absolute -top-20 -right-20 h-60 w-60 rounded-full pointer-events-none"
              style={{
                background:
                  "radial-gradient(circle, rgba(0,255,255,0.18), transparent 70%)",
              }}
            />
            <div className="flex items-center gap-3 mb-6 relative">
              <div className="h-10 w-10 rounded-xl bg-stormly-cyan/15 border border-stormly-cyan/40 flex items-center justify-center">
                <Zap size={18} className="text-stormly-cyan" />
              </div>
              <span className="text-xs tracking-[0.18em] uppercase text-stormly-cyan font-bold">
                Po burzy ze Stormly
              </span>
            </div>
            <h3 className="font-heading text-2xl md:text-3xl font-bold mb-6 relative">
              Rozwiązanie
            </h3>
            <ul className="space-y-4 relative">
              {solutions.map((s, i) => (
                <li
                  key={i}
                  className="flex items-start gap-3 text-white text-base"
                >
                  <span className="mt-2 h-1 w-6 bg-stormly-cyan shrink-0 rounded-full" />
                  {s}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
